export const NUMEROLOGY_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:5005/numerology-form"
    : "/numerology-form";